import React from "react";
import YouTube, { Options, PlayerVars } from "react-youtube";
import {
  MediaModalModel,
  MediaModalItemModel,
  MediaModalImageSlideModel,
} from "../../models/MediaModalModel";
import { MediaType } from "../../models/MediaType";
import { enableBodyScroll, disableBodyScroll } from "../../utils/dom";
import { isMobile } from "react-device-detect";
import ImgLazyLoad from "../ImgLazyLoad";

interface VideoModalState {
  content: MediaModalModel;
  currentItemIndex: number;
  currentSlideIndex: number;
  isVisible: boolean;
}

class VideoModal extends React.Component<{}, VideoModalState> {
  get currentItem(): MediaModalItemModel {
    const { currentItemIndex, content } = this.state;
    return content ? content[this.state.currentItemIndex] : null;
  }

  get currentSlideContent(): MediaModalImageSlideModel {
    const content = this.currentItem;
    return content.slides ? content.slides[this.state.currentSlideIndex] : null;
  }

  constructor(props) {
    super(props);

    this.state = {
      content: null,
      currentItemIndex: 0,
      currentSlideIndex: 0,
      isVisible: false,
    };

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleShowVideoModal = this.handleShowVideoModal.bind(this);
    this.close = this.close.bind(this);
  }

  componentWillMount() {
    document.addEventListener("keydown", this.handleKeyDown);
    window.addEventListener("showVideoModal", this.handleShowVideoModal);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    window.removeEventListener("showVideoModal", this.handleShowVideoModal);
  }

  handleKeyDown(e): boolean {
    if (this.state.isVisible && e.keyCode === 27) {
      this.close();
    }
    return true;
  }

  handleShowVideoModal(e: any): void {
    const { content, startIndex } = e.detail;
    const isVisible = true;
    const currentItemIndex = startIndex || 0;
    const currentSlideIndex = 0;
    disableBodyScroll();
    this.setState({
      content,
      isVisible,
      currentItemIndex,
      currentSlideIndex,
    });
  }

  close() {
    const isVisible = false;
    const content = null;

    enableBodyScroll();
    this.setState({ content, isVisible });
  }

  prev() {
    let currentSlideIndex = this.state.currentSlideIndex - 1;
    if (currentSlideIndex < 0)
      currentSlideIndex = this.currentItem.slides.length - 1;

    this.setState({ currentSlideIndex });
  }

  next() {
    let currentSlideIndex = this.state.currentSlideIndex + 1;
    if (currentSlideIndex >= this.currentItem.slides.length)
      currentSlideIndex = 0;

    this.setState({ currentSlideIndex });
  }

  renderVideoContent() {
    return (
      <div className="videoModal__videoDiv">
        <video
          className="videoModal__video"
          controls={true}
          autoPlay={true}
          loop={false}
          preload="auto"
          src={this.currentItem.media}
        />
      </div>
    );
  }

  renderYouTubeContent() {
    let url = this.currentItem.media;
    let videoId = url.split("/").pop();
    let playerVars: PlayerVars = {
      autoplay: 1,
    };
    const opts: Options = {
      playerVars: playerVars,
    };
    return (
      <div className="videoModal__youtubeDiv">
        <YouTube
          videoId={videoId}
          className="videoModal__iframe"
          opts={opts}
          containerClassName="videoModal__youtubeDiv"
          onReady={this._onReady}
        />
      </div>
    );
  }
  _onReady(event) {
    if (!isMobile) {
      event.target.mute();
      event.target.playVideo();
    }
  }

  renderImageContent() {
    const content = this.currentItem;

    return content.slides ? (
      this.renderSlideContent()
    ) : (
      <div
        className="videoModal__imgDiv"
        style={{ backgroundImage: `url("${content.media}")` }}
      >
        <ImgLazyLoad className="videoModal__img" src={content.media} alt="" />
      </div>
    );
  }

  renderTextContent() {
    const content = this.currentItem;

    return (
      <div className="videoModal__textDiv">
        <div dangerouslySetInnerHTML={{ __html: content.text }} />
      </div>
    );
  }

  renderSlideContent() {
    return (
      <div
        className="videoModal__imgDiv"
        style={{ backgroundImage: `url("${this.currentSlideContent.media}")` }}
      >
        <ImgLazyLoad
          className="videoModal__img"
          src={this.currentSlideContent.media}
          alt=""
        />
        <div className="videoModal__slideCopy">
          <h4 className="h4 videoModal__slideTitle">
            {this.currentSlideContent.title}
          </h4>
          <div
            className="videoModal__slideText"
            dangerouslySetInnerHTML={{ __html: this.currentSlideContent.text }}
          />
        </div>
        <div className="videoModal__controls">
          <div
            className="videoModal__control videoModal__control--prev"
            onClick={(e) => {
              e.preventDefault();
              this.prev();
            }}
          />
          <div
            className="videoModal__control videoModal__control--next"
            onClick={(e) => {
              e.preventDefault();
              this.next();
            }}
          />
        </div>
      </div>
    );
  }

  render() {
    const { isVisible } = this.state;
    const content = this.currentItem;

    return (
      <div
        className={`tinted-overlay-wrapper ${
          isVisible ? "tinted-overlay-wrapper--visible" : ""
        } `}
      >
        <div
          className={`tinted-overlay ${
            isVisible ? "tinted-overlay--visible" : ""
          } `}
        ></div>
        <section
          className={`videoModal ${isVisible ? "videoModal--visible" : ""} `}
        >
          {content ? (
            <div className="videoModal__wrap">
              <div className="videoModal__closeBtn" onClick={this.close}>
                Close Modal
              </div>

              {content.type === MediaType.YouTube &&
                this.renderYouTubeContent()}
              {content.type === MediaType.Video && this.renderVideoContent()}
              {content.type === MediaType.Image && this.renderImageContent()}
              {content.type === MediaType.Text && this.renderTextContent()}
            </div>
          ) : null}
        </section>
      </div>
    );
  }
}

export default VideoModal;
